/* ZODIGLOW BYO - predictable 2-slide autoplay, Shopify Theme Editor safe. */
(function () {
  'use strict';
  function setup(scope) {
    (scope || document).querySelectorAll('[data-zodi-byo-carousel]').forEach(function (root) {
      if (root.dataset.zodiByoReady === 'v2') return;
      var slides = Array.from(root.querySelectorAll('[data-zodi-byo-slide]'));
      if (slides.length < 2) return;
      root.dataset.zodiByoReady = 'v2';
      root.classList.add('is-js');
      var dots = Array.from(root.querySelectorAll('[data-zodi-byo-dot]'));
      var current = 0, timer = null, touchingX = null;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var drawerHost = root.closest('header-drawer');
      var drawerDetails = drawerHost && drawerHost.querySelector('#Details-menu-drawer-container');
      var requestedInterval = parseInt(root.getAttribute('data-zodi-byo-interval'), 10);
      var autoplayInterval = requestedInterval >= 2000 && requestedInterval <= 15000 ? requestedInterval : 5000;
      var intersectionObserver = null;
      var isInViewport = !drawerDetails || !('IntersectionObserver' in window);
      var hovering = false;
      function hasActiveSubmenu() {
        return drawerHost && !!drawerHost.querySelector('.menu-drawer__menu > li > details[open]');
      }
      function show(next) {
        current = (next + slides.length) % slides.length;
        root.dataset.currentSlide = String(current + 1);
        slides.forEach(function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      function stop() {
        if (timer !== null) { window.clearInterval(timer); timer = null; }
      }
      function play() {
        stop();
        if (reduced || !root.isConnected || document.hidden ||
            (drawerDetails && (!drawerDetails.open || !isInViewport || hasActiveSubmenu())) ||
            root.contains(document.activeElement) || hovering) return;
        timer = window.setInterval(function () {
          if (!root.isConnected || document.hidden ||
              (drawerDetails && (!drawerDetails.open || !isInViewport || hasActiveSubmenu()))) {
            stop();
            return;
          }
          show(current + 1);
        }, autoplayInterval);
      }
      function go(i) { show(i); play(); }
      var prev = root.querySelector('[data-zodi-byo-prev]');
      var next = root.querySelector('[data-zodi-byo-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); });
      });
      // Avoid accidental navigation on swipe inside the full-card link in the menu.
      // Preserve swipe on the non-link BYO page carousel.
      if (root.tagName !== 'A') {
        root.addEventListener('touchstart', function (event) {
          if (event.touches.length === 1) touchingX = event.touches[0].clientX;
        }, { passive: true });
        root.addEventListener('touchend', function (event) {
          if (touchingX === null || !event.changedTouches.length) return;
          var delta = event.changedTouches[0].clientX - touchingX;
          touchingX = null;
          if (Math.abs(delta) > 35) go(current + (delta < 0 ? 1 : -1));
        }, { passive: true });
      }
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) play();
      });
      root.addEventListener('mouseenter', function () { hovering = true; stop(); });
      root.addEventListener('mouseleave', function () { hovering = false; play(); });
      if (drawerDetails) {
        drawerDetails.addEventListener('toggle', function () {
          if (drawerDetails.open) play();
          else stop();
        });
        drawerHost.querySelectorAll('.menu-drawer__menu > li > details').forEach(function (details) {
          details.addEventListener('toggle', function () {
            if (details.open) stop();
            else play();
          });
        });
        if ('IntersectionObserver' in window) {
          intersectionObserver = new IntersectionObserver(function (entries) {
            isInViewport = entries.some(function (entry) { return entry.isIntersecting; });
            if (isInViewport) play();
            else stop();
          }, { threshold: 0.1 });
          intersectionObserver.observe(root);
        }
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else play();
      });
      root.addEventListener('zodi:destroy', function () {
        stop();
        if (intersectionObserver) intersectionObserver.disconnect();
      }, { once: true });
      show(0);
      play();
    });
  }
  function init() { setup(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-zodi-byo-carousel]').forEach(function (root) {
      root.dispatchEvent(new Event('zodi:destroy'));
    });
  });
})();